import type ServerGame from "../models/game";

export class UserFacingError extends Error {}

export class StartGameError extends Error {
    constructor(message, public serverGame: ServerGame) {
        super(message);
    }
}
